import React from "react"
import ConsentContext, {
  defaultConsent
} from "cookiesConsent/features/getConsent/context"
import { UserConsent } from "cookiesConsent/domain/consent"

interface ConsentProviderProps {
  consent?: UserConsent
  children: React.ReactNode
}

const ConsentProvider = ({
  consent = defaultConsent,
  children
}: ConsentProviderProps) => (
  <ConsentContext.Provider value={consent!}>{children}</ConsentContext.Provider>
)

export default ConsentProvider
